export default function parseEncodedJSON<T = unknown>(encodedStr: string): T {
	const textarea = document.createElement("textarea");
	textarea.innerHTML = encodedStr;
	const decodedStr: string = textarea.value;

	const jsonStr: string = decodedStr.replace(
		/'([^'\\]*(?:\\.[^'\\]*)*)'/g,
		(_match: string, p1: string) => {
			return JSON.stringify(p1);
		},
	);

	return JSON.parse(jsonStr) as T;
}
